module.exports = __webpack_public_path__ + "img/potenz.c7f5a01c.png";